export async function setupCoupon() {
  const params = new URLSearchParams(window.location.search);
  const vendorLogoDiv = document.getElementById('vendor-logo') as HTMLDivElement;
  const labelEl = document.getElementById('label') as HTMLSpanElement;
  const descriptionEl = document.getElementById('description') as HTMLSpanElement;
  const vendorNameEl = document.getElementById('vendor-name') as HTMLElement;
  const addressEl = document.getElementById('address') as HTMLAnchorElement;
  const confirmationDialog = document.getElementById('confirmation') as HTMLDialogElement;
  const surpriseDialog = document.getElementById('surprise-dialog') as HTMLDialogElement;
  const surpriseEl = document.getElementById('surprise') as HTMLSpanElement;
  const surpriseNotice = document.getElementById('surprise-notice') as HTMLSpanElement;
  const slider = document.getElementById('slider') as HTMLElement & { reset: () => void };
  const surpriseMessage = document.getElementById('surprise-message') as HTMLTextAreaElement;

  const hex = params.get('id');
  surpriseDialog.querySelector('.confirm')!.addEventListener('click', () => surpriseDialog.close());
  surpriseEl!.addEventListener('click', () => surpriseDialog!.showModal());

  if (!hex) return;
  fetchCoupon(hex).then((response) => {
    const vendorId = response.vendorId;
    const vendorName = response.vendorName;
    const message = response.message;
    const redirect = `/enjoy?id=${hex}`;
    if (message) {
      surpriseMessage.value = message;
      surpriseDialog.showModal();
      surpriseMessage.style.height = 'auto';
      surpriseMessage.style.height = `${surpriseMessage.scrollHeight}px`;
    } else {
      surpriseNotice.remove();
      surpriseDialog.remove();
    }
    vendorNameEl.innerHTML = vendorName;
    vendorLogoDiv.outerHTML = `<a href='/gift-form?vendor_id=${vendorId}' target='_blank'><img id="vendor-logo" class="logo" src="images/${vendorId}-logo.png" /></a>`;
    labelEl.innerHTML = response.label;
    if (response.description) {
      descriptionEl.innerHTML = response.description;
    } else {
      descriptionEl.remove();
    }
    addressEl.href = `/locations?vendor_id=${vendorId}`;
    if (response.served) {
      window.location.href = redirect;
    }
    confirmationDialog.addEventListener('close', () => slider.reset());
    confirmationDialog.querySelector('.cancel')!.addEventListener('click', () => confirmationDialog.close());
    confirmationDialog.querySelector('.confirm')!.addEventListener('click', () => {
      confirmationDialog.close();
      showRedeemingPassphrase(hex, response.label, response.description, redirect);
    });
    slider.addEventListener('unlocked', () => confirmationDialog.showModal());
  });
}

export async function setupEnjoy() {
  const hex = new URLSearchParams(window.location.search).get('id');
  const mascotEl = document.getElementById('mascot') as HTMLDivElement;
  const descriptionEl = document.getElementById('description') as HTMLSpanElement;
  const labelEl = document.getElementById('label') as HTMLSpanElement;
  const vendorLogoDiv = document.getElementById('vendor-logo') as HTMLDivElement;

  const surpriseDialog = document.getElementById('surprise-dialog') as HTMLDialogElement;
  const surpriseEl = document.getElementById('surprise') as HTMLSpanElement;
  const surpriseNotice = document.getElementById('surprise-notice') as HTMLSpanElement;
  const surpriseMessage = document.getElementById('surprise-message') as HTMLTextAreaElement;

  if (!hex) return;
  mascotEl.outerHTML = `<img class='mascot' src='images/mascot-with-cup.png' />`;
  const { vendorId, label, description, message } = await fetchCoupon(hex);

  if (message) {
    surpriseMessage.value = message;
    surpriseEl!.addEventListener('click', () => {
      surpriseDialog!.showModal();
      surpriseMessage.style.height = 'auto';
      surpriseMessage.style.height = `${surpriseMessage.scrollHeight}px`;
    });
    surpriseDialog.querySelector('.confirm')!.addEventListener('click', () => surpriseDialog.close());
  } else {
    surpriseNotice.remove();
    surpriseDialog.remove();
  }

  const sendCoffeeBtn = document.getElementById('gift-back') as HTMLButtonElement;
  const exploreBtn = document.getElementById('explore') as HTMLButtonElement;
  sendCoffeeBtn.onclick = () => window.location.assign(`/gift-form?vendor_id=${vendorId}`);
  exploreBtn.onclick = () => window.location.replace(`https://www.sipps.no`);

  labelEl.innerHTML = label;
  vendorLogoDiv.outerHTML = `<a href='/gift-form?vendor_id=${vendorId}' target='_blank'><img id="vendor-logo" class="logo" src="images/${vendorId}-logo.png" /></a>`;

  if (description) {
    descriptionEl.innerHTML = description;
  } else {
    descriptionEl.outerHTML = '';
  }
}

export async function fetchCoupon(hex: string) {
  const response = await fetch(`/api/coupon/${hex}`);
  if (!response.ok) throw new Error('Failed to fetch coupon');
  return await response.json();
}

export async function fetchPassphrase(hex: string) {
  const response = await fetch(`/api/coupon/${hex}/passphrase`);
  if (!response.ok) throw new Error('Failed to fetch passphrase');
  return await response.json();
}

export async function showRedeemingPassphrase(hex: string, label: string, description: string, redirect: string) {
  const json = await fetchPassphrase(hex);

  const overlay = document.createElement('div');
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100vw';
  overlay.style.height = '100vh';
  overlay.style.background = 'rgba(0, 0, 0, 0.8)';
  overlay.style.color = 'white';
  overlay.style.display = 'flex';
  overlay.style.flexDirection = 'column';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  overlay.style.fontSize = '1.5rem';
  overlay.style.zIndex = '9999';
  overlay.style.padding = '2rem';
  overlay.style.boxSizing = 'border-box';

  const message = document.createElement('div');
  message.textContent = json.passphrase;
  message.style.marginBottom = '1.5rem';
  message.style.textAlign = 'center';

  const itemDiv = document.createElement('div');
  itemDiv.textContent = `${label}: ${description}`;
  itemDiv.style.marginBottom = '1.5rem';
  itemDiv.style.textAlign = 'center';

  const progressBarContainer = document.createElement('div');
  progressBarContainer.style.width = '80%';
  progressBarContainer.style.height = '8px';
  progressBarContainer.style.background = 'rgba(255, 255, 255, 0.2)';
  progressBarContainer.style.borderRadius = '4px';
  progressBarContainer.style.overflow = 'hidden';

  const progressBar = document.createElement('div');
  progressBar.style.width = '0%';
  progressBar.style.height = '100%';
  progressBar.style.background = 'white';
  progressBar.style.transition = 'width 10s linear';

  // Assemble DOM
  progressBarContainer.appendChild(progressBar);
  overlay.appendChild(message);
  overlay.appendChild(itemDiv);
  overlay.appendChild(progressBarContainer);
  document.body.appendChild(overlay);

  // Start animation
  requestAnimationFrame(() => {
    progressBar.style.width = '100%';
  });

  setTimeout(() => {
    overlay.remove();
    window.location.href = redirect;
  }, 10000);
}

export function openGoogleMaps(address: string) {
  const baseUrl = 'https://www.google.com/maps/search/?api=1&query=';
  const encodedAddress = encodeURIComponent(address);
  window.open(baseUrl + encodedAddress);
}
